import { useClientConfiguration } from "hooks/api/use-client-configurations";

import { ClientConfigurationDTOConfigKey } from "generated/schemas";

export const useParentEmailRules = (clientId: string) => {
  const { data } = useClientConfiguration(
    clientId,
    ClientConfigurationDTOConfigKey.PARENT_EMAIL_PROMPT,
  );
  return data?.configValue ?? "";
};
